<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
        <button class="status-button" @click="$router.push({ name: 'Groups' })">{{ $t('groups') }}</button>
         <span> | </span>
         <button class="font-weight-bold status-button" @click="$router.push({ name: 'Variations' })">{{ $t('variations') }}</button>
         <span> | </span>
         <button class="status-button" @click="$router.push({ name: 'Characters' })">{{ $t('3dModels') }}</button>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <SingleOptionDropdown v-model="characterId" class="mx-2" :options="characters" :title="$t('character')" :index="1"></SingleOptionDropdown>
        <button type="button" class="btn btn-primary" @click="addVariation">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <!-- API errors of the list's actions (delete, status...) -->
    <FormApiErrors show-text></FormApiErrors>
    <CTableWrapper ref="table" hover striped :caption="$t('variations')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import FormApiErrors from '@/controls/FormApiErrors.vue';
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

export default {
  components: { FormApiErrors, CTableWrapper, SearchBar, SingleOptionDropdown },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'size', label: i18n.t('size'), _classes: 'font-weight-bold', sortable: true }
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'edit', label: i18n.t('edit') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'name', asc: true },
      loading: false,
      characterId: null
    }
  },
  computed: {
    ...mapState('characters', ['getCharactersOutput']),
    charactersInfo: function() {
      return this.getCharactersOutput ? this.getCharactersOutput : null;
    },
    characters: function()
    {
      var result = this.charactersInfo && this.charactersInfo.data ? this.charactersInfo.data : [];

      return result.map(x => { return { key: x.id.toString(), label: x.name } });
    },
    ...mapState('variations', ['getVariationsByCharacterIdOutput']),
    ...mapState('variations', ['deleteVariationsByIdOutput']),
    variationsInfo: function() {
      return this.getVariationsByCharacterIdOutput ? this.getVariationsByCharacterIdOutput : null;
    },
    items: function()
    {
      return this.variationsInfo?.data || [];
    },
    pages: function()
    {
      return this.variationsInfo ? this.variationsInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.loadCharacters();
  },
  methods: {
    ...mapActions('characters', ['getCharacters']),
    loadCharacters()
    {
      this.loading = true;
      this.getCharacters(new InputGetList(999, 1, '', 1, 'Name'));
    },
    ...mapActions('variations', ['getVariationsByCharacterId']),
    ...mapActions('variations', ['deleteVariationsById']),
    rowClicked (item, index) {
      this.$router.push({name: "VariationEdit", query: { id: item.id } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "VariationEdit", query: { id: item.id } });
          break;
        }
        case 'edit':
        {
          this.$router.push({name: "VariationEdit", query: { id: item.id } });
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.id, { name: item.name }))){
            this.deleteVariationsById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested()
    {
      //Make request
      this.loading = true;
      this.getVariationsByCharacterId(this.characterId); 
    },
    addVariation () 
    {
      router.push({ name: 'VariationAdd', params: { characterId: this.characterId }});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteVariationsByIdOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getVariationsByCharacterIdOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    },
    characters: function(val)
    {
      if(val != null && val.length)
      {
        this.characterId = val[0].key;
      }
    },
    characterId: function(val)
    {
      if(val != null)
      {
        this.updateItemsRequested();
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 